<template>
  <ModalMenuDownload
    v-if="item.download"
    :content="contentComputed"
    @changeMenu="$emit('setMenuOpen')"
  />
  <!-- :href="`#${item.id}`" -->
  <router-link
    class="item"
    :to="{ query: route.query, params: route.params, hash: `#${item.id}` }"
    @click="$emit('setMenuOpen')"
    v-else
  >
    <div>
      <p class="item__title">{{ item.title }}</p>
      <p class="item__subtitle">{{ item.subtitle }}</p>
    </div>
    <icon :data="pageIcons[item.icon]" class="item__icon"></icon>
  </router-link>
</template>
<script setup>
import { pageIcons } from "../../plugins/page-icons.js";
import ModalMenuDownload from "./ModalMenuDownload.vue";
// import ModalMenuChristmas from "./ModalMenuChristmas.vue";
import { useRoute } from "vue-router";
import { computed } from "@vue/reactivity";

const route = useRoute();

const props = defineProps({
  item: Object,
});

const contentComputed = computed(() =>
  route.query.book === "noidieni" ? props.item.christmas : props.item
);
</script>

<style lang="scss" scoped>
.item {
  width: 100%;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  &__title {
    @include p-l-bold;
    color: $scala-grigi-gray_1;
  }

  &__subtitle {
    @include dida-m;
    color: $scala-grigi-gray_1;
    font-style: italic;
    margin-top: toRem(5);
  }

  &__icon {
    min-height: 1.5rem;
    min-width: 1.5rem;
    color: $primary-yellow;
    opacity: 0;
    transition: opacity 0.3s linear;
  }

  &:hover {
    .item__icon {
      opacity: 1;
    }
  }

  &:first-child {
    margin-top: toRem(32);
    margin-bottom: toRem(52);
  }

  // &:last-child {
  //   margin-top: toRem(53);
  // }
}

.tablet,
.mobile {
  .item {
    &:first-child {
      margin-top: toRem(45);
      margin-bottom: toRem(72);
    }

    // &:last-child {
    //   margin-top: toRem(72);
    // }

    &__icon {
      opacity: 1;
    }
  }
}

.mobile {
  .item {
    &__title {
      @include title-h-5;
    }

    &:first-child {
      margin-top: toRem(26);
      margin-bottom: toRem(52);
    }

    // &:last-child {
    //   margin-top: toRem(52);
    // }
  }
}
</style>
